import { render } from "./AboutS3.vue?vue&type=template&id=5f84da7e&scoped=true"
import script from "./AboutS3.vue?vue&type=script&lang=js"
export * from "./AboutS3.vue?vue&type=script&lang=js"

import "./AboutS3.vue?vue&type=style&index=0&id=5f84da7e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f84da7e"]])

export default __exports__